



















import { Section } from './mixins';

import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component
export default class SectionQuestions extends Mixins(Section) {
  @Prop() readonly value!: SectionQuestions;
}
